import * as ents from '@attain-apps/entities'
import { TypeAsserter, TypeChecker } from '@attain-apps/type-guards'
import type * as rxjs from 'rxjs'

import * as gql from '../../gql'

/** Joint-use functionalizations API. */
export class Api {
  /** Gets joint-use functionalizations for an organization calculation mode. */
  public get(
    context: Api.Get.Context,
    { calculationMode, ...params }: Api.Get.Params,
  ): rxjs.Observable<ents.extra.space.Functionalization[]> {
    return gql.queries.calculatedOrgJointUseFunctionalizations.executor({
      ...context,
      ...params,
      calculationMode: TypeAsserter.validate(
        gql.enums.calculationMode.TRANSFORMER.getGqlFrom(calculationMode),
        TypeAsserter.assertIsNotNullish,
      ),
    })
  }
}

export namespace Api {
  export namespace Get {
    export type Context = ents.core.admin.Context.ForScenario
    export const isContext: TypeChecker<Context> =
      ents.core.admin.Context.ForScenario.isForScenario

    export interface Params {
      organizationId: ents.extra.space.Organization.Id
      entityId: ents.core.dms.models.Entity.Id
      calculationMode: ents.extra.space.Organization.JointUseCalculationMode
    }
    export const isParams: TypeChecker<Params> =
      TypeChecker.Factory.object<Params>({
        organizationId: ents.extra.space.Organization.Id.isId,
        entityId: ents.core.dms.models.Entity.Id.isId,
        calculationMode:
          ents.extra.space.Organization.JointUseCalculationMode
            .isJointUseCalculationMode,
      })
  }
}
